import {DataObject} from "./dataObject";

export class Vereinsdatenblatt extends DataObject {
    constructor() {
        super();
        this.id = '';
        this.sportanlage = {
            name: '',
            strasse: '',
            ort: '',
            telefon: '',
            fax: '',
            email: '',
            bahnen: {
                viererTeam: {von: 1, bis: 4},
                sechserTeam: {von: 1, bis: 4},
            }
        };
        this.trainerTeam = {
            trainer: '',
            instruktor: '',
            uebungsleiter: '',
        };
        this.obmann = {
            name: '',
            strasse: '',
            wohnort: '',
            telefon: '',
            handy: '',
            email: '',
        };
        this.sektionsleiter = {
            name: '',
            strasse: '',
            wohnort: '',
            telefon: '',
            handy: '',
            email: '',
        };
        this.sportkapitaene = [];
        this.local.definitions.databaseHandlerCall = 'vereinsdatenblatt';
    }

}

export class Sportkapitaen {
    constructor(){
        this.team = '';
        this.name = '';
        this.strasse = '';
        this.wohnort = '';
        this.telefon = '';
        this.handy = '';
        this.email = '';
    }
}